import React from "react";
import stylesASAP from "./stylesASAP";
import _post from "../Functions/Post";
import ReactToPrint from "react-to-print";
import DeliveryForm from "./DeliveryForm";
import { FcHome } from "react-icons/fc";
import { FaArrowCircleLeft } from "react-icons/fa";

export default class Print extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticate: false,
      transactionTypes: [
        {
          id: 0,
          name: "Order",
          SOs: "CreateSO?token=",
          type: "SAL",
          LS: "SO",
          signature: "updateSO?token=",
        },
        {
          id: 1,
          name: "Return",
          SOs: "CreateSO?token=",
          type: "SAL",
          LS: "Return",
          signature: "updateSO?token=",
        },
        {
          id: 2,
          name: "Purchase",
          SOs: "CreatePO?token=",
          type: "RFQ",
          LS: "PO",
          signature: "updatePO?token=",
        },
        { id: 3, name: "Invoices", signature: "updateInvoice?token=" },
        {
          id: 4,
          name: "Delivery",
          SOs: "CreateSO?token=",
          type: "DLV",
          LS: "Delivery",
          signature: "updateSO?token=",
        },
        {
          id: 5,
          name: "CashSales",
          SOs: "CreateSO?token=",
          type: "",
          LS: "SO",
          signature: "updateSO?token=",
          backButton: "CashSales",
        },
      ],

      currentType: -1,
      settingArray: [
     
      ],
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const type = localStorage.getItem("TransactionType");
    await this.setState({ currentType: JSON.parse(type) , settingArray : settingArray });
  }

  render() {
    return (
      <div>
        <FaArrowCircleLeft
          className="btn"
          onClick={() =>
            this.props.history.push(
              "./" + this.state.transactionTypes[this.state.currentType].name
            )
          }
          color={"#00bfff"}
          height="50px"
          width="40px"
          style={stylesASAP.iconhome}
        />
        {this.state.settingArray.map((item) => {
          if (item.key === "Enable_Out_of_Route_Schedule") {
            return item.value === "1" ? (
              <div>
                <FcHome
                  className="btn"
                  style={stylesASAP.iconhome}
                  onClick={() => this.props.history.push("/TransactionsPage")}
                />
              </div>
            ) : (
              <div>
                <FcHome
                  className="btn"
                  style={stylesASAP.iconhome}
                  onClick={() => this.props.history.push("/LandingPage")}
                />
              </div>
            );
          }
        })}

        <h1 className="text-center pt-5">
          {" "}
          This button allow you to print the receipt of SO{" "}
        </h1>
        <div className="text-center pt-5">
          <ReactToPrint
            trigger={() => {
              return (
                <div className="btn text-center " style={stylesASAP.wideButton}>
                  Print Transaction
                </div>
              );
            }}
            content={() => this.componentRef}
          />
          <div style={stylesASAP.displayDoc}>
            <DeliveryForm ref={(el) => (this.componentRef = el)} />
          </div>
        </div>
      </div>
    );
  }
}
